import React from 'react';
import { InputDiv } from '../../components/input';
import { variants as inputVariants } from '../../components/input/style';
import { InputProps } from '../../components/input/input';

type InputTagVariant = {
  Container: React.ElementType | 'div';
  inputProps?: InputProps;
  containerVariant?: 'clean';
  containerStyle?: any;
  growInput?: boolean;
  itemPaddingBottom: '4px' | '8px';
  disabledInputStyle?: {
    background?: 'white';
  };
};

export type VariantNames = 'input' | 'clean';

export const variants: {
  [Key in VariantNames]: InputTagVariant;
} = {
  input: {
    Container: InputDiv,
    inputProps: {
      variant: 'clean',
      size: 'auto',
    },
    containerVariant: 'clean',
    containerStyle: inputVariants.action,
    growInput: true,
    itemPaddingBottom: '4px',
    disabledInputStyle: {
      background: 'white',
    },
  },
  clean: {
    Container: 'div',
    inputProps: {
      variant: 'action',
    },
    itemPaddingBottom: '8px',
    disabledInputStyle: {},
    containerStyle: 'padding-left: 0;',
  },
};
